import { Component, CUSTOM_ELEMENTS_SCHEMA, } from '@angular/core';
import { LoaderComponent } from '../loader/loader.component';
import { SharedSnackBarComponent } from '../snackbar/shared-snack-bar.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ExternalHeaderComponent } from "../external-header/external-header.component";

@Component({
    selector: 'lib-layout-external',
    imports: [CommonModule, RouterModule, LoaderComponent, SharedSnackBarComponent, ExternalHeaderComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './layout-external.component.html',
    styleUrls: ['./layout-external.component.scss']
})

export class LayoutExternalComponent  {
    onSearch(event){
        console.log("test"+event);
    }
}
